import React, { useMemo } from 'react';

import {
  Flex, Text, HStack, Stack, Switch,
} from '@chakra-ui/react';
import { Controller, useFormContext } from 'react-hook-form';
import { useToggle } from 'react-use';

import { TextArea, Input } from 'components';
import { ChecklistFieldTypes } from 'enums/types';

import Breakdowns from './Breakdowns';
import Checklists from './Checklists';
import Images from './Images';
import VehicleImage from './VehicleImage';

export default function BaseField({
  active,
  name,
  description,
  type,
  inputs,
  index,
  options,
  allowEdition,
  execution,
  isInactive,
  forceParentReRender,
}) {
  const { register, watch } = useFormContext();
  const field = watch(`fields.${index}`) || { name, description };
  const [isEditingName, toggleName] = useToggle(false);
  const [isEditingDescription, toggleDescription] = useToggle(false);

  const Children = useMemo(() => ({
    [ChecklistFieldTypes.VehicleImage]: VehicleImage,
    [ChecklistFieldTypes.Breakdowns]: Breakdowns,
    [ChecklistFieldTypes.Checkbox]: Checklists,
    [ChecklistFieldTypes.Image]: Images,
  }[type]), [type]);

  if (!allowEdition && !active) {
    return null;
  }

  return (
    <Flex flexDirection="column">
      <Stack>
        <Flex>
          <HStack>
            {allowEdition && (
            <Controller
              name={`fields.${index}.active`}
              render={({ field: item }) => (
                <Switch
                  mt={1}
                  mr={2}
                  size="sm"
                  {...item}
                  isChecked={item.value}
                />
              )}
            />
            )}
            <Text
              hidden={isEditingName}
              onClick={() => {
                if (allowEdition) {
                  toggleName();
                }
              }}
              variant="xLargeBold">
              {field?.name}
            </Text>
            <Input
              onBlurCapture={toggleName}
              width="min"
              onMouseEnter={(e) => {
                e.currentTarget.focus();
              }}
              viewProps={{
                width: 'min',
                hidden: !isEditingName,
                alignSelf: 'center',
              }}
              defaultValue={field?.name}
              {...register(`fields.${index}.name`)}
            />
          </HStack>
        </Flex>
        <HStack>
          <Text
            hidden={isEditingDescription}
            onClick={() => {
              if (allowEdition) {
                toggleDescription();
              }
            }}
            variant="xSmallRegular">
            {field?.description}
          </Text>
          <TextArea
            onBlurCapture={toggleDescription}
            onMouseEnter={(e) => {
              e.currentTarget.focus();
            }}
            hidden={!isEditingDescription}
            defaultValue={field?.description}
            {...register(`fields.${index}.description`)}
          />
        </HStack>
        <Children
          execution={execution?.fields?.find((executionField) => name === executionField.name)}
          inputs={inputs}
          options={options}
          index={index}
          allowEdition={allowEdition}
          isInactive={isInactive}
          forceParentRerender={forceParentReRender}
        />
      </Stack>
    </Flex>
  );
}
